// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__GRDCu","productName":"Table_productName__38HHT"};